module.exports = __webpack_public_path__ + "img/login.52108d9e.png";